<!-- Above-the-fold: Load immediately -->
<div class="w-full max-w-full overflow-x-hidden">
<app-home-banner></app-home-banner>
<app-category-cards></app-category-cards>

<app-recently-viewed-parts></app-recently-viewed-parts>
<app-order-summary-stats></app-order-summary-stats>
<app-partsforyou [partType]="true"></app-partsforyou>
<app-why-choose-us-component></app-why-choose-us-component>
<app-customer-feedback></app-customer-feedback>
<app-blogs-stories></app-blogs-stories>
<app-faq></app-faq>
</div>
